<template>
  <div class="mt-200">
    <form-field-input
      label="URL"
      v-model="url"
      readonly=""
    >
      <template v-slot:after>
        <b-tooltip label="Copy URL">
          <button-icon
            icon="copy"
            @click="$utils.copyToClipboard(url)"
          ></button-icon>
        </b-tooltip>
      </template>
    </form-field-input>

    <div class="flex flex-end">
      <button-default @click="change" :loading="loading">
        Change
      </button-default>
    </div>
  </div>
</template>

<script>

export default {
  name: "CallScriptIdentifierForm",
  props: {
    callScript: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      url: '',
      loading: false,
    }
  },
  created() {
    this.url = this.callScript.url;
  },
  methods: {
    change() {
      this.loading = true;
      return this.$api.callScripts.patchIdentifier(this.callScript.id)
      .then(res => {
        this.$buefy.toast.open({
          message: "URL was updated",
          type: 'is-success'
        });

        this.url = res.data.url;
        this.validationErrors = {};
        return res;
      }).catch(error => {
        if (error.response.status === 422) {
          this.validationErrors = error.response.data.errors;
        }
      })
      .finally(() => this.loading = false);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
